module.exports = __webpack_public_path__ + "static/media/payment_icon.f3cfbab3.svg";